import * as v from 'valibot';
import { weekdaysSchema } from './Weekdays';
import { integerInRange } from '../util/valibot';
export const sunTypeSchema = v.union([
    v.literal('t'),
    v.literal('u'),
    v.literal('e'),
    v.literal('n'),
]);
export const SunAdjustSchema = integerInRange(-3, 3);
export const scheduleRandomSchema = v.union([
    v.literal('r0'),
    v.literal('r5'),
    v.literal('r15'),
]);
export const sunSchema = v.object({
    k: sunTypeSchema,
    a: SunAdjustSchema,
    w: weekdaysSchema,
    r: scheduleRandomSchema,
});
export function isSunType(s) {
    return ['t', 'u', 'e', 'n'].includes(s);
}
export function isScheduleRandom(s) {
    return ['r0', 'r5', 'r15'].includes(s);
}
